/*
    text match:
    Jean
    jean
    Jean-Pierre
    Jean Pierre
    jean-pierre
    jean pierre
    Jean-pierre
    Jean pierre
    jean-Pierre
    jean Pierre
*/

export const textRegex = /^([a-zA-ZÜ-ü- ]+)$/mi;


/*
    phone match:
    +330642129037
    +33642129037
    330642129037
    00330642129037
    0330642129037
    0642129037
    642129037
    06.42.12.90.37
    06-42-12-90-37
    00642129037
    06 42 12 9037
*/
export const phoneRegex = /^(\+33|\+330|0|00|33|330|0033|033|0330|00330|)([1-9]{1})(([ .-]?\d{2}){4})$/mi

/*
    number match:
    1.5
    1,5
    1
    1234567890
*/
export const numberRegex = /^([\d.,]+)$/mi

/*
    email match:
    test@test.fr
    test@test.com
    test@test.co.uk
    test.test@test.fr
    test.test@test.com
    test.test@test.co.uk
    test-test@test.fr
    test-test@test.com
    test-test@test.co.uk
    test+test@test.fr
    test+test@test.com
    test+test@test.co.uk
    t@test.fr
    t@test.com
    t@test-test.co.uk
*/
export const emailRegex = /^\w+([+.-]?\w+)*@([\w-]*)(\.\w{2,3}){1,2}$/mi
